import { render, staticRenderFns } from "./PMStructureTaskForm.vue?vue&type=template&id=4f4e0028&"
import script from "./PMStructureTaskForm.vue?vue&type=script&lang=ts&"
export * from "./PMStructureTaskForm.vue?vue&type=script&lang=ts&"
import style0 from "./PMStructureTaskForm.vue?vue&type=style&index=0&id=4f4e0028&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports